import {
  TBooleanState,
} from '../../utils/boolean.ts';

const tooltip: Record<TBooleanState, string> = {
  nullish: 'Nicht definiert',
  true: 'Wahr',
  false: 'Falsch',
};

export default tooltip;
